import { useTracking } from '@change-corgi/core-react/tracking';

type Result = ModelHookResult<
	{
		ctaUrl: string;
	},
	{
		onCtaClick: () => void;
	}
>;

export function useMidPageCta(): Result {
	const track = useTracking();

	const ctaUrl = '/nonprofit/claim/search?source=nonprofit-lp';

	return {
		actions: {
			onCtaClick: () => {
				void track('nonprofit_start_petition_click', { source_location: 'mid_page' });
			},
		},
		data: {
			ctaUrl,
		},
	};
}
